import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { FormUtilitiesModule } from './ds24-ui/form-utilities';
import { WrapperComponent } from './components/wrapper/wrapper.component';
import { ToasterModule } from '@digistore/ds24-ui/toaster';
import { Wrapper2Component } from './components/wrapper2/wrapper2.component';
import { PaymentProgressIndicatorComponent } from './components/payment-progress-indicator/payment-progress-indicator.component';
import { OverlayModule } from '@angular/cdk/overlay';
import { PlainModeToggleComponent } from './components/plain-mode-toggle/plain-mode-toggle.component';

@NgModule({
  imports: [
    ToasterModule,
    FormUtilitiesModule,
    CommonModule,
    ReactiveFormsModule,
    HttpClientModule,
    OverlayModule,
    PlainModeToggleComponent,
  ],
  declarations: [WrapperComponent, PaymentProgressIndicatorComponent, Wrapper2Component],
  exports: [WrapperComponent],
})
export class WidgetsModule {}
